import { PerfectDriveDriverDetailModel } from 'common/model/statistics';
import { useTranslation } from 'react-i18next';
import DriverBehaviorCoachTable, { DriverBehaviorCoachTableColors, DriverBehaviorCoachTableModel } from '.';
import { DriverBehaviorCoachDataMap } from '../DriverBehaviorCoach';
import { formatDriverBehaviorName, getPerfectDriveValue } from 'logic/driver-behavior-coach/driver-behavior-trucks';

interface Props {
    data?: PerfectDriveDriverDetailModel;
    comparedData?: PerfectDriveDriverDetailModel;
    dataMap: DriverBehaviorCoachDataMap[];
    selectedKey?: string;
    qa?: string;
}

export default function DriverBehaviorCoachEcoTable(props: Props) {
    const { t } = useTranslation();

    const getDriverData = (data: PerfectDriveDriverDetailModel): DriverBehaviorCoachTableModel => {
        const detail = data.scores[0].detail;
        return {
            name: formatDriverBehaviorName(data.name, data.surname, data.tachocard),
            values: {
                highway: Object.fromEntries(
                    props.dataMap
                        .filter(dm => dm.values?.highway)
                        .map(dm => [dm.key, getPerfectDriveValue(dm.values?.highway, detail, 0)])
                ),
                urban: Object.fromEntries(
                    props.dataMap
                        .filter(dm => dm.values?.urban)
                        .map(dm => [dm.key, getPerfectDriveValue(dm.values?.urban, detail, 0)])
                ),
                country: Object.fromEntries(
                    props.dataMap
                        .filter(dm => dm.values?.country)
                        .map(dm => [dm.key, getPerfectDriveValue(dm.values?.country, detail, 0)])
                ),
                other: Object.fromEntries(
                    props.dataMap
                        .filter(dm => dm.values?.other)
                        .map(dm => [dm.key, getPerfectDriveValue(dm.values?.other, detail, 0)])
                ),
                summary: Object.fromEntries(
                    props.dataMap
                        .filter(dm => dm.values?.summary)
                        .map(dm => [dm.key, getPerfectDriveValue(dm.values?.summary, detail, 0)])
                )
            }
        } as DriverBehaviorCoachTableModel;
    };

    const getData = (): any[] => {
        let driverData = [];

        if (props.data) {
            driverData.push(getDriverData(props.data));
        }

        if (props.comparedData) {
            driverData.push(getDriverData(props.comparedData));
        }

        return driverData;
    };

    return (
        <DriverBehaviorCoachTable
            title={t('DriverBehaviorDetail.ecoData.title')}
            dataMap={props.dataMap}
            selectedKey={props.selectedKey}
            color={DriverBehaviorCoachTableColors.eco}
            collapsedRows={5}
            driversList={getData()}
        />
    );
}
